/* 
Since the map was loaded on client side, 
we need to make this component client rendered as well else error occurs
*/
'use client';

//Map component Component from library
import { GoogleMap, MarkerF } from '@react-google-maps/api';

//Map's styling
export const defaultMapContainerStyle = {
  width: '100%',
  height: '560px',
};
//K2's coordinates
const defaultMapCenter = {
  lat: 50.0905198,
  lng: 14.4252192,
};

//Default zoom level, can be adjusted
const defaultMapZoom = 18;

//Map options
const defaultMapOptions = {
  zoomControl: true,
  tilt: 0,
  gestureHandling: 'auto',
  mapTypeId: 'roadmap',
} as google.maps.MapOptions;

const MapComponent = () => {
  return (
    <div style={{ width: '100%' }}>
      <GoogleMap
        mapContainerStyle={defaultMapContainerStyle}
        center={defaultMapCenter}
        zoom={defaultMapZoom}
        options={defaultMapOptions}
      >
        <MarkerF position={defaultMapCenter} />
      </GoogleMap>
    </div>
  );
};

export { MapComponent };
